import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { LoansService, StorageService } from 'src/app/_services';

@Component({
  selector: 'app-request-hero',
  templateUrl: './request-hero.component.html',
  styleUrls: ['./request-hero.component.css']
})
export class RequestHeroComponent implements OnInit {

  @Output() bookanewloan = new EventEmitter();
  loading = false;
  currentUser: any;
  total: string;

  constructor(
    public loansService: LoansService,
    public storageService: StorageService,
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    this.getPendingRequestsLength();
  }

  getPendingRequestsLength() {
    this.loading = true;
    this.loansService.getPendingRequestsLength(this.currentUser.token).subscribe(({ data }) => {
      this.loading = false;
      this.total = parseFloat(data.total_principal).toFixed(2);
    }, err => {
      this.loading = false;
      console.log({ err });
    })
  }
}
